import './assets/index.css'
import Vue from 'vue'
Vue.config.productionTip = false

if (window.xtooltech) Vue.use(window.xtooltech.default)

/*导入element-ui*/
import './plugins/element.js'

/*导入自定义组件*/
import './components'

/*导入路由*/
import router from './router'

/*导入store*/
import store from './store'


new Vue({
	router,
	store,
	computed: {
	},
	methods: {
		getNickName(){
			var token=localStorage.getItem("token");
			var userInfo=JSON.parse(token);
			//"{"access_token":"YR7xGVyMnV5RRXQmJPlL","id":"20051141","nick_name":"封华","expire":1600920917458}"
			var nickName=userInfo.nick_name;
			return nickName;
		},
	},
	render: h => h(require('./App.vue').default)
}).$mount('#app')
